import * as actions from './actions';
import * as types from './mutation-types';

const state = {
    loading: false,
    error: '',
    facilities: [],
    currentFacility: {},
    facilityUsersList: [],
    userForFacility: [],
    userForFacilityError: {},
    userForFacilityLoading: 0,
    facilityData: {},
    getNavigationMenusError: '',
    getNavigationMenusLoading: 0,
    navigationMenus: []
};

const getters = {
    facilitiesLoading: state => state.loading,
    facilitiesError: state => state.error,
    userFacilities: state => state.facilities,
    currentFacility: state => state.currentFacility,
    facilityUsersList: state => state.facilityUsersList,
    userForFacility: state => state.userForFacility,
    userForFacilityError: state => state.userForFacilityError,
    userForFacilityLoading: state => state.userForFacilityLoading,
    facilityData: state => state.facilityData,
    createdNavigationMenu: state => state.createdNavigationMenu,
    navigationMenus: state => state.navigationMenus,
    getNavigationMenusError: state => state.getNavigationMenusError,
    getNavigationMenusLoading: state => state.getNavigationMenusLoading,
}

const mutations = {
    [types.GET_FACILITIES_REQUEST](state){
        state.loading = true;
        state.error = '';
        state.facilities = [];
    },
    [types.GET_FACILITIES_FAILURE](state, error){
        state.loading = false;
        state.error = error;
        state.facilities = [];
    },
    [types.GET_FACILITIES_SUCCESS](state, facilities){
        state.loading = false;
        state.error = '';
        state.facilities = facilities
    },
    [types.GET_FACILITY_USERS_LIST_REQUEST](state){
        state.loading = true;
        state.error = '';
        state.facilityUsersList = [];
    },
    [types.GET_FACILITY_USERS_LIST_FAILURE](state, error){
        state.loading = false;
        state.error = error;
        state.facilityUsersList = [];
    },
    [types.GET_FACILITY_USERS_LIST_SUCCESS](state, facilityUsersList){
        state.loading = false;
        state.error = '';
        state.facilityUsersList = facilityUsersList
    },
    [types.REQUEST_ACCESS_REQUEST](state){
        state.loading = true;
        state.error = '';
        state.facilities = [];
    },
    [types.REQUEST_ACCESS_FAILURE](state, error){
        state.loading = false;
        state.error = error;
        state.facilities = [];
    },
    [types.GET_FACILITY_BY_ID_REQUEST](state){
      state.loading = true;
      state.error = '';
      state.currentFacility = {};
    },
    [types.GET_FACILITY_BY_ID_SUCCESS](state, facility){
      state.loading = false;
      state.error = '';
      state.currentFacility = facility;
    },
    [types.GET_FACILITY_BY_ID_FAILURE](state, error){
      state.loading = false;
      state.error = error;
      state.currentFacility = {};
    },
    [types.GET_USERS_FOR_FACILITY_REQUEST](state){
      state.userForFacilityLoading = true;
      state.userForFacilityError = '';
      state.userForFacility = [];
    },
    [types.GET_USERS_FOR_FACILITY_SUCCESS](state, userForFacility){
      state.userForFacilityLoading = false;
      state.userForFacilityError = '';
      state.userForFacility = userForFacility;
    },
    [types.GET_USERS_FOR_FACILITY_FAILURE](state, userForFacilityError){
      state.userForFacilityLoading = false;
      state.userForFacilityError = userForFacilityError;
      state.userForFacility = [];
    },
    [types.GET_ACTIVE_FACILITIES_REQUEST](state, error){
      state.loading = true;
      state.error = error;
      state.facilities = [];
    },
    [types.GET_ACTIVE_FACILITIES_SUCCESS](state, facilities){
      state.loading = false;
      state.facilities = facilities;
    },
    [types.GET_ACTIVE_FACILITIES_FAILURE](state, error){
      state.loading = false;
      state.facilities = [];
      state.error = error;
    },
    [types.GET_FACILITY_DATA_REQUEST](state, error){
        state.loading = true;
        state.error = error;
    },
    [types.GET_FACILITY_DATA_SUCCESS](state, facilityData){
        state.loading = false;
        state.facilityData = facilityData;
    },
    [types.GET_FACILITY_DATA_FAILURE](state, error){
        state.loading = false;
        state.error = error;
    },
    [types.GET_NAVIGATION_MENUS_REQUEST](state){
    state.getNavigationMenusLoading = true
    state.getNavigationMenusError = ''
    state.navigationMenus = []
    },
    [types.GET_NAVIGATION_MENUS_SUCCESS](state, navigationMenus){
      state.getNavigationMenusLoading = false
      state.getNavigationMenusError = ''
      state.navigationMenus = navigationMenus
    },
    [types.GET_NAVIGATION_MENUS_FAILURE](state, error){
      state.getNavigationMenusLoading = false
      state.getNavigationMenusError = error
      state.navigationMenus = []
    }
}

export default {
    state,
    actions,
    getters,
    mutations
}
